module.exports = __webpack_public_path__ + "media/images/document-847362e2d1aa13877fac170d3a0d643a.png";